/** Base URL API: default same-origin `/api/` (nginx o proxy Vite). Override con VITE_API_BASE. */
function normalizeApiBase(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return "/api/";
  return trimmed.endsWith("/") ? trimmed : `${trimmed}/`;
}

const envBase = import.meta.env.VITE_API_BASE as string | undefined;
export const API_BASE = envBase ? normalizeApiBase(envBase) : "/api/";
